module.exports = __webpack_public_path__ + "static/media/logo.22e67ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo.png
// module id = 806
// module chunks = 0